var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgScienceFiction = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Science-Fiction-Weapon--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Science Fiction Weapon Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 20.94a0.5 0.5 0 0 0 0 -0.24l-3.48 -9.32a6 6 0 0 1 2.28 -7.31 0.46 0.46 0 0 0 0.2 -0.38 0.49 0.49 0 0 0 -0.17 -0.41c-2.32 -2 -7.39 -1.35 -10 -0.14 -1.28 0.59 -2 1.28 -2 2v1.11a0.25 0.25 0 0 1 -0.25 0.25h-0.7a0.25 0.25 0 0 1 -0.25 -0.25V4a0.75 0.75 0 0 0 -1.5 0v2.25a0.25 0.25 0 0 1 -0.25 0.25h-0.75a0.25 0.25 0 0 1 -0.25 -0.25V5a1 1 0 0 0 -2 0v1.25a0.25 0.25 0 0 1 -0.25 0.25h-0.76a0.26 0.26 0 0 1 -0.21 -0.11A2 2 0 1 0 2 9.5a2 2 0 0 0 1.66 -0.89 0.26 0.26 0 0 1 0.21 -0.11h0.76a0.25 0.25 0 0 1 0.25 0.25V10a1 1 0 0 0 2 0V8.75a0.25 0.25 0 0 1 0.25 -0.25h0.75a0.25 0.25 0 0 1 0.25 0.25V11a0.75 0.75 0 0 0 1.5 0V8.75a0.25 0.25 0 0 1 0.25 -0.25h0.75a0.25 0.25 0 0 1 0.25 0.25v3.75a6.37 6.37 0 0 0 5.53 4 0.26 0.26 0 0 1 0.23 0.19 5.18 5.18 0 0 1 -0.57 4.13 0.76 0.76 0 0 0 0.68 1.18H23c0.28 0 0.87 -0.11 1 -1.06ZM13.88 8.5a0.51 0.51 0 0 1 -0.5 -0.5V7a0.5 0.5 0 0 1 0.5 -0.5h3a0.5 0.5 0 0 1 0.5 0.5v1a0.5 0.5 0 0 1 -0.5 0.5Zm-0.46 4.93a0.38 0.38 0 0 1 0.25 -0.67h2a0.39 0.39 0 0 1 0.37 0.29l0.28 1.15a0.35 0.35 0 0 1 -0.09 0.35 0.38 0.38 0 0 1 -0.36 0.11 6 6 0 0 1 -2.45 -1.23Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgScienceFiction);
export default ForwardRef;